module.exports = __webpack_public_path__ + "web/img/gezi.2f79e9a6.png";